export default function HistoryConversation() {
  return <div className="xl:px-4 py-4">History Conversations</div>;
}
